import * as Yup from "yup";
import { Formik } from "formik";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { filter, isEqual, map, omit, unionBy } from "lodash";
import { titleCaseString } from "utils/helpers";
import { Button, Dropdown, Modal, TextArea, Textinput } from "components";
import {
  addProject,
  updateProject,
  setProjectEditData,
  setIsShowProjectPopup,
  throwError,
} from "store/globalSlice";
import "./Projectpopup.scss";

const Projectpopup = ({ fetchProjects }) => {
  const dispatch = useDispatch();
  const reduxData = useSelector((state) => state.global);
  const { isShowProjectPopup, projectEditData, networkType, isSubscription, isDarkMode } =
    reduxData || {};

  const [btnLoading, setBtnLoading] = useState(false);
  const isEdit = projectEditData?.project_id ? true : false;

  const handleSubmit = (values) => {
    setBtnLoading(true);
    if (projectEditData?.project_id) {
      handleEdit(values);
    } else {
      handleAdd(values);
    }
  };

  const handleAdd = async (values) => {
    if (isSubscription) {
      const response = await dispatch(addProject(values));
      if (response?.status === 201) {
        fetchProjects();
        dispatch(setIsShowProjectPopup(false));
        dispatch(setProjectEditData(null));
      }
    } else {
      dispatch(
        throwError("Please select subscription for complete this action.")
      );
    }
    setBtnLoading(false);
  };

  const handleEdit = async (values) => {
    const response = await dispatch(
      updateProject(
        projectEditData?.project_id,
        omit(values, ["type", "sub_type"])
      )
    );
    if (response?.status === 201) {
      fetchProjects();
      dispatch(setIsShowProjectPopup(false));
      dispatch(setProjectEditData(null));
    }
    setBtnLoading(false);
  };

  const validationSchema = Yup.object().shape({
    // name: Yup.string().required("Project name is required."),
    // type: Yup.string().required("Chain type is required."),
    // sub_type: Yup.string().email("Chain sub type is required."),
  });

  const initialValues = {
    name: projectEditData?.name || "",
    type: projectEditData?.type || "",
    sub_type: projectEditData?.sub_type || "",
    description: projectEditData?.description || "",
  };

  return (
    <div id="projectpopup-container">
      {isShowProjectPopup && (
        <Modal
          width="650px"
          title={isEdit ? "Edit project" : "Create new project"}
          onHide={() => {
            dispatch(setIsShowProjectPopup(false));
            dispatch(setProjectEditData(null));
          }}
          isDarkMode={isDarkMode}
        >
          <Formik
            initialValues={initialValues}
            onSubmit={handleSubmit}
            validationSchema={validationSchema}
          >
            {(props) => {
              const { values, handleChange, handleSubmit } = props;
              const { name, type, sub_type, description } = values;
              const networkList = filter(
                networkType,
                (elm) => elm.type === type
              );

              return (
                <form className="row cps-26 cpe-26 cpt-26">
                  <div className="cmb-24">
                    <Textinput
                      id="name"
                      label="Name"
                      value={name}
                      placeholder="Name"
                      onChange={handleChange}
                      isDarkMode={isDarkMode}
                      required={true}
                    // maxLength="30"
                    />
                  </div>
                  <div className="col-md-6 cmb-24">
                    <Dropdown
                      id="type"
                      label="Chain"
                      value={type}
                      onChange={handleChange}
                      placeholder="Select chain"
                      options={map(unionBy(networkType, "type"), (elem) => {
                        return {
                          id: elem?.type,
                          label: titleCaseString(elem?.type),
                        };
                      })}
                      disabled={isEdit}
                      isDarkMode={isDarkMode}
                      required={true}
                    />
                  </div>
                  <div className="col-md-6 cmb-24">
                    <Dropdown
                      id="sub_type"
                      label="Network"
                      value={sub_type}
                      onChange={handleChange}
                      placeholder="Select network"
                      options={
                        isEdit
                          ? [{ id: sub_type, label: titleCaseString(sub_type) }]
                          : map(networkList, (elm) => {
                            return {
                              id: elm?.sub_type,
                              label: titleCaseString(elm?.sub_type),
                            };
                          })
                      }
                      disabled={isEdit}
                      isDarkMode={isDarkMode}
                      required={true}
                    />
                  </div>
                  <div className="cmb-24">
                    <TextArea
                      rows={3}
                      id="description"
                      label="Description"
                      value={description}
                      onChange={handleChange}
                      placeholder="Description"
                      isDarkMode={isDarkMode}
                    />
                  </div>
                  <div className="d-flex justify-content-end">
                    <Button
                      btnStyle="PD"
                      onClick={handleSubmit}
                      loading={btnLoading}
                      btnText={isEdit ? "Save Changes" : "Create project"}
                      disabled={isEdit ? isEqual(initialValues, values) : !name}
                    />
                  </div>
                </form>
              );
            }}
          </Formik>
        </Modal>
      )}
    </div>
  );
};

export default Projectpopup;
